<script setup lang="ts">
import { EPageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'

const { storageUrl } = useStorageService()

const data = ref<
	| {
			[key: string]: any
	  }[]
	| undefined
>()

const { getLocaleLang } = usei18nService()
const bannerIMG = ref<string>()

const props = defineProps<{
	pageType?: string
	page?: string
}>()

const pageSections = inject<Ref<IHomePageSectionModel[]>>('pageSections')!

const assignBannerIMG = () => {
	if (!pageSections.value) return null
	const section = pageSections.value?.find((section) => section.name === EPageSectionType.PARAGRAFS_HEADER)
	if (section && section.files && section.files.length > 0) {
		const img = section.files[0].path
		if (img) bannerIMG.value = img
	}
}

if (!pageSections && props.pageType && props.page) {
	try {
		const paragraphs = await ApiService.fetchPageSectionByName(props.pageType, props.page, EPageSectionType.PARAGRAFS_HEADER)
		if (paragraphs) {
			data.value = paragraphs?.translations.find((t) => t.language === getLocaleLang())?.content
			assignBannerIMG()
		}
	} catch (error) {
		logger.log(error)
	}
}

watch(
	() => pageSections?.value,
	(newValue) => {
		if (newValue) {
			const section = newValue.find((section) => section.name === EPageSectionType.PARAGRAFS_HEADER)
			if (section) {
				data.value = section.translations.find((t) => t.language === getLocaleLang())?.content
				assignBannerIMG()
			}
		}
	},
	{ immediate: true, deep: true },
)

assignBannerIMG()
</script>

<template>
	<div data-aos="fade-up" class="seo-banner">
		<div class="seo-banner__gradient"></div>
		<h3
			class="seo-banner__title"
			v-html="data && data[0].title ? data[0].title : detectNewline($t('components.seo_section.banner.your_journey'))"></h3>
		<GlobalImage
			class="seo-banner__image"
			:src="bannerIMG ? `${storageUrl}${bannerIMG}` : 'seo-banner.png'"
			alt="seo-banner"
			:width="1240"
			:height="226" />
		<GlobalImage
			class="seo-banner__image seo-banner__image--mobile"
			:src="bannerIMG ? `${storageUrl}${bannerIMG}` : 'seo-banner-mobile.png'"
			alt="seo-banner-mobile"
			:height="343" />
		<!-- <GlobalImage v-if="!bannerIMG" class="seo-banner__image-mask" src="seo-banner-mask.png" alt="seo-banner" :width="1240" :height="226" /> -->
		<!-- <GlobalImage
			v-if="!bannerIMG"
			class="seo-banner__image-mask seo-banner__image-mask--mobile"
			src="seo-banner-mask-mobile.png"
			alt="seo-banner-mobile-mask"
			:height="343" /> -->
	</div>
</template>

<style lang="scss" scoped src="./Banner.scss"></style>
